<template>
  <tr>
    <template v-for="column in headers">
      <td
        v-if="column.key === 'icons'"
        :key="column.key"
        class="b2b-grid__cell lg:table-cell whitespace-nowrap"
        :class="column.cssClasses"
      >
        <div class="flex flex-nowrap">
          <grid-icon v-if="item.isSplitWarehouse" :data="{value: 'call_split'}" />
          <grid-note
            v-show="item.lineComment || false"
            :row-id="item.id"
            :data="{
              value: 'insert_drive_file',
              content: item.lineComment,
              editable: false,
              cssClass: 'ml-1',
            }"
          />
        </div>
      </td>

      <td
        v-else-if="column.key === 'etaWatch'"
        :key="column.key"
        class="b2b-grid__cell lg:table-cell whitespace-nowrap"
        :class="[column.cssClasses]"
      >
        <div class="b2b-grid__label" v-html="column.label"></div>

        <div :id="`p1-tooltip-${itemIndex}`" v-tippy-html>
          {{ p1WatchMessage }}
        </div>

        <div class="b2b-grid__content">
          <div>
            <form id="etaWatchForm"></form>
            <button
              v-tippy="{
                html: `#p1-tooltip-${itemIndex}`,
                interactive: false,
                reactive: true,
                trigger: item.p1flag ? 'mouseenter focus' : 'manual',
                flip: true,
                sticky: true,
              }"
              :disabled="isProcessing"
              class="b2b-grid__stock-watch__indicator"
              :class="[{'text-success': item.etaToggle === true}, {disabled: item.p1flag === true}]"
              @click="updateEtaWatch"
            >
              <i class="b2b-grid__stock-watch__icon material-icons">
                {{ item.etaToggle === true ? 'visibility' : 'visibility_off' }}
              </i>
              <span class="b2b-grid__stock-watch__label b2b-grid__stock-watch__label font-medium">
                {{ getBaseProperty('watch') }}
              </span>
            </button>
          </div>
        </div>
      </td>

      <grid-cell
        v-else-if="consumerFriendlyMode && (column.key != 'unitPrice' || column.key != 'lineSubtotal')"
        :key="column.key"
        :cell-key="column.key"
        :label="column.label"
        :qaid="`order-detail-item-${column.key}`"
        :value="itemData[column.key]"
        :classes="[
          {
            'whitespace-nowrap': column.key === 'icons',
            'w-1': column.key !== 'itemName',
          },
          column.cssClasses,
        ]"
      >
      </grid-cell>

      <grid-cell
        v-else-if="column.key === 'lineStatus'"
        :key="column.key"
        :cell-key="column.key"
        :label="column.label"
        :qaid="`order-detail-item-${column.key}`"
        :value="itemData[column.key]"
        class="whitespace-nowrap w-1"
        :class="column.cssClasses"
      >
        <pdl-label kind="default" class="align-self-top mr-0">
          <span v-html="bp(item[column.key])" />
        </pdl-label>
      </grid-cell>
      <grid-cell
        v-else
        :key="column.key"
        :cell-key="column.key"
        :label="column.label"
        :qaid="`order-detail-item-${column.key}`"
        :value="itemData[column.key]"
        :classes="[
          {
            'whitespace-nowrap': column.key === 'icons',
            'w-1': column.key !== 'itemName',
          },
          column.cssClasses,
        ]"
      >
      </grid-cell>
    </template>
  </tr>
</template>

<script>
import axios from 'axios';
import find from 'lodash/find';
import {mapGetters} from 'vuex';
import {PdlLabel} from '@pedal/pdl-label';

export default {
  components: {
    PdlLabel,
  },
  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: () => {},
    },
    itemIndex: {
      type: Number,
      default: 0,
    },
    headers: {
      type: Array,
      default: () => [],
    },
    selectable: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      notesEditable: false,
      isProcessing: false,
    };
  },

  computed: {
    row() {
      return this.item;
    },
    p1WatchMessage() {
      return this.bp('p1Watch');
    },
    itemData() {
      const data = this.item;
      data['unitPrice'] = data.basePrice?.formattedValue;
      data['lineSubtotal'] = data.totalPrice?.formattedValue;
      if (data.etaDate && this.bp(data.etaDate)) {
        data.etaDate = this.bp(data.etaDate);
      }
      return data;
    },
    ...mapGetters('backend', ['consumerFriendlyMode']),
  },

  methods: {
    getBaseProperty(name) {
      let baseProperty = find(this.baseProperties, (baseProperty) => baseProperty.name === name);
      return baseProperty ? baseProperty.label : '';
    },

    updateEtaWatch() {
      const token = $('[name="CSRFToken"]').val();
      const {sku, warehouse, orderLineNumber, orderNumber, orderType, orderCompany} = this.item;

      const payload = {
        sku,
        warehouse,
        orderLineNumber,
        orderNumber,
        orderType,
        orderCompany,
      };
      this.isProcessing = true;
      if (this.item.p1flag === true) {
        // P1 items cannot change watch status
      } else if (this.item.etaWatchId && this.item.etaToggle === true) {
        // If the item already has an ETA Watch, we send a delete request
        axios
          .delete(`/my-account/etawatch/${this.item.etaWatchId}`, payload)
          .then(() => {
            this.item.etaToggle = false;
            this.item.etaWatchId = null;
            this.isProcessing = false;
          })
          .catch((error) => console.log(error));
      } else {
        // If the item has no ETA Watch then send a POST request
        axios
          .post(`/my-account/etawatch?CSRFToken=${token}`, payload)
          .then(({data}) => {
            this.item.etaToggle = data.data.success;
            this.item.etaWatchId = data.data.id;
            this.isProcessing = false;
          })
          .catch((error) => console.log(error));
      }
    },
  },
};
</script>
